import { render, staticRenderFns } from "./ReviewStatusEdit.vue?vue&type=template&id=883e10e8&scoped=true"
import script from "./ReviewStatusEdit.vue?vue&type=script&lang=js"
export * from "./ReviewStatusEdit.vue?vue&type=script&lang=js"
import style0 from "./ReviewStatusEdit.vue?vue&type=style&index=0&id=883e10e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883e10e8",
  null
  
)

export default component.exports